<template>
  <div class="background" v-if="type !== 'end'">
    <div class="container">
      <div class="logo">
        <img src="../static/NEOCONF2020.png" alt="logo" />
      </div>
      <div v-if="type === 'login'">
        <div class="text">
          Авторизация
        </div>

        <form id="login" @submit.prevent="login()">
          <label for="email">Логин</label>
          <input id="email" v-model="email" type="text" />
          <label for="password">Пароль</label>
          <input id="password" v-model="password" type="password" />
          <button @click="login()">Войти</button>
        </form>
      </div>
      <div v-if="type === 'registration'">
        <div class="text">
          Регистрация на конференцию
        </div>

        <form id="register" @submit.prevent="live()">
          <label for="surname"> Имя Фамилия </label>
          <input
            id="surname"
            type="text"
            v-model="name"
            minlength="3"
            required
          />
          <label for="company"> Компания </label>
          <input
            id="company"
            type="text"
            v-model="company"
            minlength="3"
            required
          />
          <div class="help-wrapper">
            <label for="instagram"> Instagram </label>
            <img
              class="help-show"
              src="../static/question.svg"
              alt="question"
            />
            <span class="help-text hide"
              >Укажите адрес вашей страницы в Instagram и вы сможете принять
              участие в интерактивах на online-платформе Конференции</span
            >
          </div>
          <div class="input-wrapper">
            <input
              id="input-before"
              disabled
              value="www.instagram.com/"
              type="text"
            />
            <input id="instagram" type="text" v-model="instagram" />
          </div>
          <div class="button__register">
            <button @click="live()">Зарегистрироваться</button>
            <button @click="type = 'end'">Нет, спасибо</button>
          </div>
          <span
            >Нажимая на кнопку, вы даете согласие на обработку персональных
            данных и соглашаетесь с
            <a href="/privacy">политикой конфиденциальности</a>
          </span>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'login',
  data() {
    return {
      type: 'login',
      email: '',
      password: '',
      name: '',
      company: '',
      instagram: '',
    };
  },
  methods: {
    async login() {
      try {
        const data = new FormData();
        data.append('email', this.email);
        data.append('password', this.password);
        const result = await axios.post(
          'https://neconf.devgg.ru/auth.php',
          data
        );

        if (data.errors) {
          throw new Error(result.status);
        } else {
          console.log(result.success);
          this.type = 'registration';
        }
      } catch (e) {
        console.log(e);
      }
    },
    async live() {
      try {
        const data = {
          event: 'register',
          name: this.name,
          company: this.company,
          instagram: this.instagram,
        };
        const result = await axios.post(
          'https://eapteka.zapto.org/event',
          JSON.stringify(data)
        );
        if (data.errors) {
          throw new Error(result.status);
        } else {
          this.type = 'end';
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style scoped>
.button__register {
  display: flex;
  justify-content: space-between;
}
@media screen and (max-width: 867px) {
  .button__register {
    flex-direction: column;
  }
  .button__register button:first-child {
    margin-bottom: 15px;
  }
}
.background {
  background-image: url(../static/register_back.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  min-height: 1000px;
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 7000;
}
@media screen and (max-width: 867px) {
  .background {
    overflow: scroll;
    min-height: auto !important;
    padding: 20px;
    box-sizing: border-box;
    overflow-x: hidden;
  }
}
.background .container {
  width: 450px;
  padding: 100px;
  background-color: #00000070;
  box-shadow: 4px 4px 15px black;
}
.background .container .logo {
  margin-bottom: 60px;
  padding: 0 25px;
}
.background .container .logo img {
  width: 100%;
}
.background .container .text {
  color: #fff;
  font-weight: bold;
  font-size: 26px;
  margin-bottom: 60px;
  text-align: center;
}
.background .container form {
  display: flex;
  flex-direction: column;
}
.background .container form label {
  color: #fff;
}
.background .container form .input-icon {
  color: #fff;
  position: absolute;
}
.background .container form .input-wrapper {
  position: relative;
  width: 100%;
}
.background .container form .input-wrapper input#input-before {
  width: 150px;
  float: left;
}
.background .container form .input-wrapper input#instagram {
  width: calc(100% - 150px);
  float: left;
}
.background .container form input {
  color: #fff;
  margin: 5px 0 30px 0;
  padding: 10px 0;
  line-height: 20px;
  border: 0;
  border-bottom: 1px solid #ffffff;
  background-color: #00000000;
  outline: 0;
  outline-offset: 0;
  border-radius: 0;
  opacity: 1;
}
.background .container form button {
  margin: 50px auto 0 auto;
  padding: 20px 30px;
  border-radius: 10px;
  border: 0;
  background-color: #8968ec;
  color: #fff;
  transition: 0.5s;
  outline: 0;
  outline-offset: 0;
}
.background .container form button:hover {
  box-shadow: 4px 4px 5px black;
  background-color: #00bf9d;
}
.background .container form .help-wrapper {
  display: flex;
  width: 100%;
  justify-content: space-between;
  position: relative;
}
.background .container form .help-wrapper img {
  height: 15px;
  cursor: pointer;
}
.background .container form .help-wrapper .help-show:hover + .help-text {
  opacity: 1;
}
.background .container form .help-wrapper .help-text {
  width: 200px;
  margin-top: 0;
  padding: 10px;
  position: absolute;
  top: -15px;
  left: calc(100% + 15px);
  border-radius: 5px;
  background-color: #8867ea;
  box-shadow: 4px 4px 5px black;
  opacity: 1;
  transition: 0.5s;
  z-index: 1;
  cursor: default;
  pointer-events: none;
}
.background .container form .help-wrapper .help-text.hide {
  opacity: 0;
}
.background .container form span {
  text-align: center;
  color: #fff;
  font-size: 12px;
  margin-top: 50px;
}
.background .container form span a {
  color: #8867ea;
  text-decoration: none;
  transition: 0.2s;
}
.background .container form span a:hover {
  color: #00bf9d;
}
@media (max-width: 1000px) {
  .background {
    min-height: 1500px;
  }
  .background .container {
    width: 100%;
    margin: 40px;
    padding: 120px 50px;
    font-size: 32px;
  }
  .background .container .text {
    text-align: center;
    font-size: 44px;
    margin-bottom: 100px;
  }
  .background .container form button {
    padding: 35px 50px;
  }
  .background .container form span {
    margin-top: 60px;
    font-size: 20px;
  }
  .background .container form .input-wrapper input#input-before {
    width: 300px;
  }
  .background .container form .input-wrapper input#instagram {
    width: calc(100% - 300px);
    float: left;
  }
  .background .container form .help-wrapper img.help-show {
    height: 32px;
  }
  .background .container form .help-wrapper .help-text {
    left: unset;
    right: 0;
    top: 40px;
    width: 400px;
  }
}
</style>
